import React from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { redirectWithSavingScroll } from 'swag-client-common/utils/tricks';
export const SeeMoreButton = ({
  className
}) => /*#__PURE__*/React.createElement(Button, {
  dataButton: "See More Aw You Guys",
  type: "primary",
  className: className,
  onClick: redirectWithSavingScroll(APP_ROUTES.REVIEWS)
}, "See More");